import {
  Terminal,
  Briefcase,
  Cpu,
  FolderGit2,
  FileText,
  MapPin,
  Linkedin,
  Github,
  Shield
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { DATA_FR } from '../data/fr';
import { LABELS } from '../data/labels';

export const Sidebar = ({
  activeSection,
  setActiveSection,
  data,
  labels,
}: {
  activeSection: string,
  setActiveSection: (s: string) => void,
  data: typeof DATA_FR,
  labels: typeof LABELS['fr'],
}) => {
  const navItems = [
    { id: 'overview', label: labels.overview, icon: Terminal },
    { id: 'experience', label: labels.experience, icon: Briefcase },
    { id: 'skills', label: labels.skills, icon: Cpu },
    { id: 'projects', label: labels.projects, icon: FolderGit2 },
    { id: 'badges', label: labels.badges || 'Certifications', icon: Shield },
    { id: 'cv', label: labels.cv, icon: FileText },
  ];

  return (
    <div className="w-80 hidden lg:block p-4">
      <div className="sticky top-8 space-y-4">
        {/* Profile Card - Material 3 Style */}
        <div className="bg-surface-container-lowest rounded-[24px] p-6 text-center shadow-sm border border-outline-variant/20">
          {/* Avatar */}
          <div className="relative mx-auto mb-4 w-24 h-24">
            <div className="w-full h-full rounded-full bg-gradient-to-br from-primary via-primary/80 to-tertiary flex items-center justify-center text-on-primary text-3xl font-bold shadow-elevation-2">
              PT
            </div>
            <div
              className={`absolute bottom-1 right-1 w-6 h-6 rounded-full border-4 border-surface-container-lowest ${data.personal.availability.includes('listening') || data.personal.availability.includes('écoute')
                ? 'bg-tertiary'
                : 'bg-[#108548]'
                }`}
              title={data.personal.availability}
            />
          </div>

          {/* Name & Role */}
          <h2 className="font-bold text-on-surface text-xl mb-1">{data.personal.name}</h2>
          <p className="text-sm text-on-surface-variant mb-4">{data.personal.role}</p>

          {/* Location */}
          <div className="flex items-center justify-center gap-1.5 text-xs text-on-surface-variant mb-6">
            <MapPin className="w-3.5 h-3.5" />
            {data.personal.location}
          </div>

          {/* Social Links - Tonal Buttons */}
          <div className="flex gap-3 justify-center">
            <a
              href={`https://${data.personal.linkedin}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-surface-container-high hover:bg-surface-container-highest text-on-surface transition-colors"
              title="LinkedIn"
            >
              <Linkedin className="w-5 h-5" />
            </a>
            <a
              href={`https://${data.personal.github}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-surface-container-high hover:bg-surface-container-highest text-on-surface transition-colors"
              title="GitHub"
            >
              <Github className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Navigation Drawer - Now contained for better visual separation */}
        <div className="bg-surface-container-lowest rounded-[24px] p-2 shadow-sm border border-outline-variant/20">
          <nav className="space-y-1">
            {navItems.map(item => (
              <button
                key={item.id}
                onClick={() => setActiveSection(item.id)}
                className={`w-full nav-item ${activeSection === item.id ? 'active' : ''}`}
              >
                <item.icon className={`w-5 h-5 ${activeSection === item.id ? 'text-on-secondary-container' : 'text-on-surface-variant'}`} />
                {item.label}
              </button>
            ))}


          </nav>
        </div>

        {/* Footer Actions */}
        <div className="pt-2 flex justify-between items-center px-4">
          <div className="text-xs text-on-surface-variant/60">
            © {new Date().getFullYear()} - UI Material Design 3 Expressive
          </div>
          <Link
            to="/admin"
            className="p-2 text-on-surface-variant hover:text-primary hover:bg-primary-container/20 rounded-full transition-colors"
            title="Admin"
          >
            <Shield className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
};
